import LandingNav from "@/components/LandingNav/LandingNav";

// Keep the branded navigation destinations in one place so every page uses
// the same labels, ordering, and purchase call to action.
const primaryNavItems = [
  { label: "Lore Vault", to: "/lore_vault" },
  { label: "Trailer", to: "/book" },
  { label: "A Note From Me", to: "/author" },
];

const buyNowItem = { label: "Buy Now", to: "/#purchase" };

/**
 * Supplies the site-wide Oathbound navigation configuration to the reusable
 * responsive navbar presentation.
 */
export default function OathboundNav() {
  return (
    <LandingNav primaryItems={primaryNavItems} ctaItem={buyNowItem} />
  );
}
